import React, { useState } from 'react';
import RichTextEditor from './RichTextEditor';

export default function ReviewComponent({ heading, text, setValue }) {
  const fontFamilies = [
    'Poppins',
    'Sans Serif',
    'Arial',
    'Georgia',
    'Times New Roman',
    'Verdana',
    'Trebuchet MS',
    'Courier New',
    'Lucida Sans',
    'Playfair Display',
  ];

  const [undoStack, setUndoStack] = useState([]);
  const [redoStack, setRedoStack] = useState([]);
  const [selectedFont, setSelectedFont] = useState(fontFamilies[0]);
  const [fontSize, setFontSize] = useState(16);

  const updateText = (newText) => {
    if (text !== newText) {
      setUndoStack((prev) => [...prev, text]);
      setRedoStack([]); // clear redo on new action
      setValue(newText);
    }
  };

  const copyToClipboard = (cut = false) => {
    navigator.clipboard
      .writeText(text)
      .then(() => {
        if (cut) updateText('');
      })
      .catch((err) => {
        console.error('Failed to copy text: ', err);
      });
  };

  const handleUndo = () => {
    if (!undoStack.length) return;
    const previousText = undoStack[undoStack.length - 1];
    setUndoStack((prev) => prev.slice(0, -1));
    setRedoStack((prev) => [...prev, text]);
    setValue(previousText);
  };

  const handleRedo = () => {
    if (!redoStack.length) return;
    const nextText = redoStack[redoStack.length - 1];
    setRedoStack((prev) => prev.slice(0, -1));
    setUndoStack((prev) => [...prev, text]);
    setValue(nextText);
  };

  return (
    <div className="flex flex-col border border-[#DEDEDE] rounded-xl h-[16rem]">
      <div className="bg-[#015A52] text-white p-2 text-base sm:text-xl rounded-t-xl">
        {heading}
      </div>
      <div className="border-b border-[#DEDEDE] p-1 overflow-x-auto">
        <RichTextEditor
          copyToClipboard={copyToClipboard}
          undo={handleUndo}
          redo={handleRedo}
          fontFamilies={fontFamilies}
          setSelectedFont={setSelectedFont}
          setFontSize={setFontSize}
        />
      </div>
      <textarea
        type="text"
        value={text}
        style={{ fontFamily: selectedFont, fontSize: `${fontSize}px` }}
        className="p-2 outline-none bg-transparent min-h-[150px]"
        onChange={(e) => updateText(e.target?.value)}
      />
    </div>
  );
}
